import situationroom01 from "../images/situationroom/p1.jpg";
import situationroom02 from "../images/situationroom/p2.jpg";


const situationroomConfig = {
    ch:
        {   title:'戰情室',
            img1:situationroom01,
            img2:situationroom02,
            introduction1:[ '戰情室提供資訊匯流的整合方案，協助客戶彙整關鍵的管理指標，讓決策更加精準。',
                            '戰情室彙整ERP、MES、CRM等系統，使重要資訊匯流到電子看板上呈現，讓客戶能快速檢閱營運目標、銷售實績、市場分析，乃至全球生產線及人、機稼動率的具體表現等。',
                            '以軟體即時派播畫面至三顯Full HD螢幕，使軟體效益視覺化，並有效呈現指標數據與焦點現場畫面，適用於大型戰情室或集團展示空間。',
                        ],
            introduction2:[ [
                            ['1/','優化管理全球業務'],
                            ['2/','數位化目標與實績']
                            ],
                            [
                            ['3/','客製化的彙整功能'],
                            ['4/','個人化的介面設定']
                            ]
                        ],
        },
    en:
        {   title:'Situation Room',
            img1:situationroom01,
            img2:situationroom02,
            introduction1:[ 'Situation Room is a system integrated solution that enables visualization of KPI review for decision making.',
                            'By integration of ERP, APS, CRM and PLM software, all valuable information, such as corporate objectives, sales performance, market analysis, machine and labor utilization are displayed on the dashboard that permit precise monitoring and management.',
                            'This solution offers 3 screens of full HD LCD display. Key performance of the entire factories is easily seen in a glance.'
                        ],
            introduction2:[ [
                            ['1/','Optimizing global production management'],
                            ['2/','KPI Dashboard']
                            ],
                            [
                            ['3/','Systems Integration for Manufacturing Applications'],
                            ['4/','Customizable display setting']
                            ]
                        ],
        }
}

export default situationroomConfig;